import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the WithdrawMoneySelectorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-withdraw-money-selector',
  templateUrl: 'withdraw-money-selector.html',
})
export class WithdrawMoneySelectorPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WithdrawMoneySelectorPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/withdraw-money-selector/withdraw-money-selector.ts